import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Comparison from "@/components/Comparison";
import Manifesto from "@/components/Manifesto";
import PerksShowcase from "@/components/PerksShowcase";
import Destinations from "@/components/Destinations";
import Perks from "@/components/Perks";
import LeadMagnet from "@/components/LeadMagnet";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import InquiryForm from "@/components/InquiryForm";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <Comparison />
      <Manifesto />
      <PerksShowcase />
      <Destinations />
      <Perks />
      <LeadMagnet />
      <Gallery />
      <Testimonials />
      <InquiryForm />
      <Footer />
      <StickyMobileCTA />
    </main>
  );
}
